(() => {
  const cartAutoUpdate = (window.MXCartAutoUpdate =
    window.MXCartAutoUpdate || {});

  const CONFIG = {
    autoUpdateDelayMs: 650,
    terminalEraseDelayMs: 18,
    terminalTypeDelayMs: 26,
    cartSectionId: 'cart',
  };

  const SELECTORS = {
    cartPage: '.cart-page',
    cartForm: '.cart-form',
    cartItem: '.cart-item',
    cartEmptyState: '.cart-empty-state',
    subtotalStrong: '.cart-subtotal strong',
    cartItemPrice: '.cart-item-price',
    quantityInput: 'input[name="updates[]"]',
    quantityStepper: '[data-quantity-stepper]',
    quantityActionButton: '[data-quantity-action]',
    decreaseButton: '[data-quantity-action="decrease"]',
    removeLink: '.cart-remove-link',
    terminal: '[data-terminal]',
    terminalLine: '[data-terminal-line]',
    terminalLabel: '.terminal__label',
    terminalValue: '.terminal__value',
  };

  const wait = (ms) =>
    new Promise((resolve) => {
      window.setTimeout(resolve, ms);
    });

  const parseMin = (input) => {
    const min = Number.parseInt(input.min, 10);

    if (Number.isNaN(min)) {
      return 1;
    }

    return min;
  };

  const parseMax = (input) => {
    if (!input.max) {
      return Number.POSITIVE_INFINITY;
    }

    const max = Number.parseInt(input.max, 10);

    if (Number.isNaN(max)) {
      return Number.POSITIVE_INFINITY;
    }

    return max;
  };

  const clampQuantity = (value, input) => {
    const min = parseMin(input);
    const max = parseMax(input);

    return Math.max(min, Math.min(max, value));
  };

  const isQuantityReadyForSubmit = (input) => {
    const rawValue = input.value.trim();

    if (rawValue === '') {
      return false;
    }

    const value = Number.parseInt(rawValue, 10);

    if (Number.isNaN(value)) {
      return false;
    }

    return value >= parseMin(input) && value <= parseMax(input);
  };

  const syncDecreaseButtonState = (input) => {
    const stepper = input.closest(SELECTORS.quantityStepper);

    if (!(stepper instanceof Element)) {
      return;
    }

    const decreaseButton = stepper.querySelector(SELECTORS.decreaseButton);

    if (!(decreaseButton instanceof HTMLButtonElement)) {
      return;
    }

    const min = parseMin(input);
    const value = Number.parseInt(input.value, 10);
    const isRemoveState = !Number.isNaN(value) && value <= min;
    const decreaseLabel = decreaseButton.dataset.labelDecrease;
    const removeLabel = decreaseButton.dataset.labelRemove;

    decreaseButton.classList.toggle('is-remove', isRemoveState);

    if (isRemoveState) {
      if (removeLabel) {
        decreaseButton.setAttribute('aria-label', removeLabel);
      }

      return;
    }

    if (decreaseLabel) {
      decreaseButton.setAttribute('aria-label', decreaseLabel);
    }
  };

  const hasFocusedQuantityInput = (form) => {
    const activeElement = document.activeElement;

    return (
      activeElement instanceof HTMLInputElement &&
      activeElement.name === 'updates[]' &&
      form.contains(activeElement)
    );
  };

  const getQuantityInputFromActionButton = (button) => {
    const stepper = button.closest(SELECTORS.quantityStepper);

    if (!(stepper instanceof Element)) {
      return null;
    }

    const input = stepper.querySelector(SELECTORS.quantityInput);

    if (!(input instanceof HTMLInputElement)) {
      return null;
    }

    return input;
  };

  Object.assign(cartAutoUpdate, {
    CONFIG,
    SELECTORS,
    wait,
    parseMin,
    parseMax,
    clampQuantity,
    isQuantityReadyForSubmit,
    syncDecreaseButtonState,
    hasFocusedQuantityInput,
    getQuantityInputFromActionButton,
  });
})();
